module.exports = __webpack_public_path__ + "static/bg.30e326d7.png";